import type { FormField } from '@cli-types/core-engine/schema.js'

export function buildWatchDecls(fields: FormField[]): { setup: string; hasWatch: boolean } {
  const watchFields = new Set<string>()
  for (const f of fields) {
    if (f.showWhen) {
      watchFields.add(f.showWhen.field)
    }
  }
  if (watchFields.size === 0) return { setup: '', hasWatch: false }
  const decls = Array.from(watchFields)
    .map((wf) => `  const ${wf}Value = form.watch('${wf}')`)
    .join('\n')
  return { setup: `\n${decls}\n`, hasWatch: true }
}
